define('model/disclosure.documents.model',['require','exports','module','fukit','fukit'],function (require, exports, module) {

    var BaseModel = require('fukit').BaseModel,
        BaseCollection = require('fukit').BaseCollection;

    var DocumentsModel = BaseModel.extend(
        {
            radioRequests: {
                'models DocumentsModel': '@constructor',
            },

            virtual: {

             urlForFiles: {
                 urlRoot: '/api/v1/attachments/files/',
                 get: function () {
                     return this.urlRoot;
                 }
             },
            },

            fileUrlTemplate: '/api/v1/attachments/files/{id}',


            save: function (attrs, options) {


                return BaseModel.prototype.save.call(
                    this,
                    attrs,
                    _.extend(
                        {
                            url: this.fileUrlTemplate,
                            type: 'PUT',
                        },
                        options
                    )
                );
            },
        },

        {
            Collection: BaseCollection.extend({
                url: '/api/v1/attachments/files',
            }),
        });

    module.exports = DocumentsModel;
});


